/**
 * Class BaseInterceptors
 */
export default class BaseInterceptors {

    /**
     * Adds base interceptors to an AxiosInstance
     *
     * @param instance
     */
    static addBaseInterceptors (instance) {
        this._extractResponseFromError(instance);
    }

    /**
     * Extracts the response from an error, when a promise is rejected
     *
     * @param {AxiosInstance} instance
     * @private
     */
    static _extractResponseFromError (instance) {
        instance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            return Promise.reject(error.response);
        });
    }

}



// WEBPACK FOOTER //
// ./src/interceptors/BaseInterceptors.js